import { AdviseLabels } from "../enums/MessageEnum";
import Title from "../elements/Title";
import { faKey, faLightbulb, faLock, faMessage, faTv, faUserGroup } from "@fortawesome/free-solid-svg-icons";
import ServiceCard from "../elements/ServiceCard";
import SelectorCard from "../elements/SelectorCard";
import serviceEmpresarial from "../assets/img/services/servicio_empresarial.jpg";
import serviceMantencion from "../assets/img/services/servicio_mantencion.jpg";
import serviceConsultoria from "../assets/img/services/servicio_tecnologia.jpg";
import serviceCiberseguridad from "../assets/img/services/ciberseguridad.jpg";
import serviceTecnologia from "../assets/img/services/soluciones_tecno.jpg";
import serviceSoftware from "../assets/img/services/licencias_software.webp";

export default function Services(props){

    const showNewDesignLayout = true //SWITCH THIS TO SHOW ONE SERVICE SELECTOR OR ANOTHER

    const services = [
        {
            name: AdviseLabels.SERVICE_SOFTWARE_TITLE,
            description: AdviseLabels.SERVICE_SOFTWARE_DESCRIPTION,
            image: serviceEmpresarial,
            resume: AdviseLabels.SERVICE_SOFTWARE_RESUME,
            value: faLightbulb
        },
        {
            name: AdviseLabels.SERVICE_MANTENCION_TITLE,
            description: AdviseLabels.SERVICE_MANTENCION_DESCRIPTION,
            image:serviceMantencion,
            resume: AdviseLabels.SERVICE_MANTENCION_RESUME,
            value: faTv
        },
        {
            name: AdviseLabels.SERVICE_CONSULTORIA_TITLE,
            description: AdviseLabels.SERVICE_CONSULTORIA_DESCRIPTION,
            image: serviceConsultoria,
            resume: AdviseLabels.SERVICE_CONSULTORIA_RESUME,
            value: faUserGroup
        },
        {
            name: AdviseLabels.SERVICE_CIBERSEGURIDAD_TITLE,
            description: AdviseLabels.SERVICE_CIBERSEGURIDAD_DESCRIPTION,
            image: serviceCiberseguridad,
            resume: AdviseLabels.SERVICE_CIBERSEGURIDAD_RESUME,
            value: faLock
        },
        {
            name: AdviseLabels.SERVICE_SOLUCION_TITLE,
            description: AdviseLabels.SERVICE_SOLUCION_DESCRIPTION,
            image: serviceTecnologia,
            resume: AdviseLabels.SERVICE_SOLUCION_RESUME,
            value: faMessage
        },
        {
            name: AdviseLabels.SERVICE_LICENCIA_TITLE,
            description: AdviseLabels.SERVICE_LICENCIA_DESCRIPTION,
            image: serviceSoftware,
            resume: AdviseLabels.SERVICE_LICENCIA_RESUME,
            value: faKey
        }
    ]
    
    return(
        <div id='services' className="information-subsection bg-gray-150">
            <Title title={AdviseLabels.SERVICES_TITLE}/>
            <div className="card-container">
            {
                services.map(function(serviceIndex, serviceValue){
                    if (!showNewDesignLayout)
                        return(
                            <div className="card-small-pad" key={serviceIndex.name}>
                                <ServiceCard name={serviceIndex.name} 
                                            icon={serviceIndex.value}
                                            image={serviceIndex.image}
                                            style={{paddingBottom: "10px", cursor: "pointer"}}
                                            description={serviceIndex.description}
                                            key={serviceIndex.name}
                                />
                            </div>
                        );
                    return(
                        <SelectorCard name={serviceIndex.name} 
                        description={serviceIndex.description}
                        icon={serviceIndex.value}
                        image={serviceIndex.image}
                        style={{padding: "40px 40px", cursor: "pointer"}}
                        isWhite={serviceValue % 2}
                        key={serviceIndex.name}
                        isLargeScreen={props.isLargeScreen}
                        resume={serviceIndex.resume}/>
                    );
                })
            }
            </div>
        </div>
    )
}